import { Radio, RadioGroup } from "@headlessui/react";
import React from "react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const FilterNavigation = ({ options, setSelectedRadio, selectedRadio }) => {
  const selectedValue =
    selectedRadio && typeof selectedRadio === "object"
      ? selectedRadio.value
      : selectedRadio;
  const selectedOption =
    options.find((o) => o.value === selectedValue) ?? options[0];

  return (
    <fieldset className="flex-shrink-0">
      <legend className="sr-only">Weergave</legend>
      <RadioGroup
        value={selectedOption}
        onChange={setSelectedRadio}
        className="inline-flex rounded-xl border border-wa-border bg-wa-panel p-1 shadow-sm"
      >
        {options.map((option) => (
          <Radio key={option.name} value={option} className="outline-none">
            {({ checked }) => (
              <span
                className={classNames(
                  "flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg transition-colors",
                  checked
                    ? "bg-wa-accent text-wa-onaccent shadow-sm"
                    : "text-wa-muted hover:bg-wa-hover hover:text-wa-text"
                )}
                aria-hidden
              >
                <option.icon className="h-5 w-5" />
              </span>
            )}
          </Radio>
        ))}
      </RadioGroup>
    </fieldset>
  );
};

export default FilterNavigation;
